import Title from "./Title";
import Slider from "react-slick";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
export default function AdditionalServices(props) {
    const [width, setWidth] = useState();
    useEffect(() => {
        setWidth(window.innerWidth);
    }, []); 
    var settings = {
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        arrows: true,
        dots: true,
        speed: 800,
        centerPadding: '0px',
        infinite: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    infinite: true,
                    slidesToScroll: 1,
                }
            },
            { 
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    infinite: false,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const data =  props && props.data;
    return <>
        <div className="additionalServices py-5" >
            <div className="container position-relative" >
                <div className="svgWrap" >
                    <svg width="624" height="678" viewBox="0 0 624 678" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.1" filter="url(#filter0_f_1312_10196)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M481.209 352.001C470.173 386.669 444.914 413.19 422.037 441.462C402.326 465.821 381.32 487.535 356.292 506.373C328.414 527.356 302.122 556.558 267.273 557.946C232.311 559.339 202.951 533.407 174.067 513.634C146.911 495.044 127.575 469.427 104.166 446.286C72.1264 414.612 16.8334 396.642 10.5661 352.001C4.50732 308.845 48.4887 275.35 75.3531 241.061C99.1624 210.671 125.738 183.755 158.438 163.262C192.015 142.219 228.082 115.019 267.273 120.785C306.401 126.54 323.038 176.499 359.088 192.779C401.116 211.758 463.755 185.58 491.836 222.192C518.703 257.222 494.604 309.919 481.209 352.001Z" fill="#FF9900" />
                        </g>
                        <defs>
                            <filter id="filter0_f_1312_10196" x="-110" y="0" width="734" height="678" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                                <feGaussianBlur stdDeviation="60" result="effect1_foregroundBlur_1312_10196" />
                            </filter>
                        </defs>
                    </svg>
                </div>

                <Title mainClass="text-center m-auto d-table"
                    titleclass="lg text-dark mb-2"
                    desclass="text-center w-75 m-auto d-table mt-3 mb-2"
                    title={<>{props && props.title}</>}
                    des={props && props.des} />

                <div className="serviceSlider mt-2 mt-lg-4" >
                    <Slider {...settings}>
                        {data && data.map((m, i) => {
                            return <>
                                <div key={i} className="serVBox" >
                                    <h2 className="pb-2 m-0" >{m.title}</h2>
                                    <p className="pb-2 m-0" >{m.des}</p>
                                    <Link to="/" >Read More</Link>
                                </div>
                            </>
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    </>
}